import "./styles.less";

import React, { useContext } from "react";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import Head from "next/head";
import { useSEO } from "../hook";

export const BreadCrumbs = ({customSeoMetaTags}) => {
	const { seoMetaTags, error, loading } = customSeoMetaTags ? 
		{seoMetaTags: customSeoMetaTags, error: false, loading: false}
		: useSEO();
	const { main_domain } = useContext(ConfigStateContext);

	if (loading || error || !seoMetaTags) return null;

	const jsonData = {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: seoMetaTags.breadcrumbs?.filter(e => e.text && e.url)
			.map((item, i) => ({
				"@type": "ListItem",
				position: i + 1,
				name: item.text,
				item: `https://${main_domain}${item.url}`,
			})),
	}

	return <>
		<Head>
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: JSON.stringify(jsonData),
				}}></script>
		</Head>


		<div className="page-breadcrumb body body-2 body-regular medium">
			 <span>Estás en:</span> {/* TODO: Cambiar a OpenSearch cuando se agreguen los seoMetaTags */}
			{seoMetaTags.breadcrumbs?.map((item, i) => <React.Fragment key={i}>
				{i > 0 && item.text != "" && <span className="breadcrumb-separator">{'>'} </span>}
				<a href={item.url}>{item.text}</a>
			</React.Fragment>)}
		</div>
	</>
}
